// extracted by mini-css-extract-plugin
module.exports = {"check":"NpsSurvey_check__zuzQX","checked":"NpsSurvey_checked__ekatY","questionChoice":"NpsSurvey_questionChoice__P72D5"};